module.exports = __webpack_public_path__ + "media/images/icon_search_address-b1958b7ce88035b5e2959c0d57ef79cc.png";